/*------------------------------------*\
    MODULES
\*------------------------------------*/
import EmailValidation from './modules/email-validation';
import Accordion from './modules/accordion';
import CharacterCount from './modules/character-count';
//import ConsultationCountdown from './modules/consultation-countdown';
import FeedbackProgress from './modules/feedback-progress';
import FormChangeTracker from './modules/form-change-tracker';
import FormReview from './modules/form-review';
import FormSave from './modules/form-save';
import PasteWarning from './modules/paste-warning';
import SiteHead from './modules/site-head';
import TypeMate from 'typemate';
import zoomedImg from './modules/zoomed-img';
import VideoModal from "./modules/video-modal";

/*------------------------------------*
    APP
\*------------------------------------*/
const app = {

    init() {
        this.noJs();
        this.alwaysLoad();
        this.nodelistPolyfill();
        this.bind();
    },

    bind() {

        // Load any items that need modules
        let modulePlaceHolders = [...document.querySelectorAll('[data-module]')];

        // No modules so bail
        if (!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map((item) => {

            // Attempt to load any modules
            let modules = item.getAttribute('data-module');

            if (!modules.length) {
                return false;
            }

            // Split the modules into an array
            modules = modules.trim().split(',');

            // Loop and bind to relevant modules
            modules.map((module) => {

                switch (module.trim()) {

                    case 'character-count':

                        let characterCountInstance = new CharacterCount(item);

                        characterCountInstance.init();

                        break;
                    /*
                    case 'consultation-countdown':

                        let consultationCountdownInstance = new ConsultationCountdown;

                        consultationCountdownInstance.init();

                        break;
                    */
                    case "video-modal":
                        let videoModalInstance = new VideoModal(item);

                        videoModalInstance.init();

                        break;

                    case 'email-validation':

                        let emailValidationInstance = new EmailValidation;

                        emailValidationInstance.init();

                        break;

                    // case 'faq-accordion':

                    //     let faqAccordionInstance = new Accordion(item);

                    //     faqAccordionInstance.init();

                    //     break;

                    case 'feedback-progress':

                        let feedbackProgressInstance = new FeedbackProgress;

                        feedbackProgressInstance.init();

                        break;

                    case 'form-change-tracker':

                        let formChangeTrackerInstance = new FormChangeTracker(item);

                        formChangeTrackerInstance.init();

                        break;

                    case 'form-review':

                        let formReviewInstance = new FormReview(item);

                        formReviewInstance.init();

                        break;

                    case 'form-save':

                        let formSaveInstance = new FormSave(item);

                        formSaveInstance.init();

                        break;

                    case 'paste-warning':

                        let pasteWarningInstance = new PasteWarning(item);

                        pasteWarningInstance.init();

                        break;

                    case 'site-head':

                        let siteHeadInstance = new SiteHead(item);

                        siteHeadInstance.init();

                        break;

                    case 'zoomed-image':

                        let zoomedImageInstance = new zoomedImg(item);

                        zoomedImageInstance.init();

                        break;
                }
            });
        });
    },

    alwaysLoad() {
        const typeMateInstance = new TypeMate();
        typeMateInstance.apply();
    },

    noJs() {
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
    },

    nodelistPolyfill() {
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }
    }
};

// Launch
app.init();
